import { ReportParams } from '../types';

interface QueryParams {
    [key: string]: string;
}

interface PubParams {
    platform: string;
    url: string;
    urlparams: string;
    referer: string;
    refdomain: string;
    referparams: string;
}

// 原生解析 URL 参数，兼容性更好
const parseQueryString = (queryString: string): QueryParams => {
    const params: QueryParams = {};
    if (!queryString) {
        return params;
    }

    const query = queryString.indexOf('?') === 0 ? queryString.slice(1) : queryString;
    const pairs = query.split('&');

    for (const pair of pairs) {
        const [key, value] = pair.split('=');
        if (key) {
            params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        }
    }

    return params;
};

// 获取公共参数
const getPubParams = (): PubParams => {
    const { href, search } = window.location;
    const queryParams = parseQueryString(search);

    return {
        platform: 'pc',
        url: href,
        urlparams: JSON.stringify(queryParams),
        referer: document.referrer,
        refdomain: '',
        referparams: ''
    };
};

/**
 * 触发埋点
 *  page: page,
    action: commonParam.action,
    extJson: { ...this.defaultOpt.extJson, ...extJson, ...commonParam.extJson }
 */
function log(reportData: ReportParams) {
    const { eventId, actionType, extJson } = reportData;

    const pub_params = getPubParams();

    window.WMDA_REPORT &&
        window.WMDA_REPORT('custom', {
            ...extJson,
            event_id: eventId,
            pageType: '',
            actionType,
            pub_params,
            _bg: 'HRG'
        });
}
export default log;
